export const getFileData = {
    computed: {
        getFileData() {
            return (file) => {
                const {name, type} = file;
                return {
                    ...file,
                    ext: `.${name.split('.').pop()}`,
                    url: this.isImage(type) ? URL.createObjectURL(file) : '',
                    isImage: this.isImage(type)
                }
            }
        },
        isImage() {
            return (fileType) => {
                return ['jpg', 'jpeg', 'png', 'gif', 'svg'].some((imageType) => fileType.includes(imageType));
            }
        }
    }
}